export default {
  name: 'BaseNotification',
  props: {
    type: {
      type: String,
      default: 'success',
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: [String, Error,],
      default: '',
    },
    close: {
      type: Function,
      default: () => ({}),
    },
  },
};
